'use strict';

/* globals swfobject */

var assign = require('lodash.assign');
var isFunction = require('lodash.isfunction');
var difference = require('lodash.difference');
var log = require('loglevel');
var Promise = require('bluebird');
var Authenticator = require('./Authenticator');
var EventEmitter = require('events');

// log.enableAll();
// log.setLevel('warn');

/**
 * Adobe Pass implementation of the abstract Authenticator class.
 * @class AdobePassAuthenticator
 * @augments Authenticator
 */
function AdobePassAuthenticator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var elementId = _ref.elementId;
    var _ref$redirectUrl = _ref.redirectUrl;
    var redirectUrl = _ref$redirectUrl === undefined ? '' : _ref$redirectUrl;
    var _ref$environment = _ref.environment;
    var environment = _ref$environment === undefined ? AdobePassAuthenticator.Environment.PRODUCTION : _ref$environment;
    var _ref$refreshless = _ref.refreshless;
    var refreshless = _ref$refreshless === undefined ? false : _ref$refreshless;
    var _ref$displayProviderD = _ref.displayProviderDialogImpl;
    var displayProviderDialogImpl = _ref$displayProviderD === undefined ? function () {
        return new Promise();
    } : _ref$displayProviderD;
    var _ref$accessEnableImpl = _ref.accessEnableImpl;
    var accessEnableImpl = _ref$accessEnableImpl === undefined ? AdobePassAuthenticator.AccessEnablerType.JAVASCRIPT : _ref$accessEnableImpl;

    if (!(this instanceof AdobePassAuthenticator)) {
        return new AdobePassAuthenticator({ elementId: elementId, redirectUrl: redirectUrl, environment: environment, refreshless: refreshless,
            displayProviderDialogImpl: displayProviderDialogImpl, accessEnableImpl: accessEnableImpl });
    }

    assign(this, EventEmitter.prototype, Authenticator.prototype);

    var REQUESTOR = 'ESPN';
    var CONTAINER_ELEMENT_ID = elementId;
    var SWF_URLS = {};
    SWF_URLS[AdobePassAuthenticator.Environment.PRODUCTION] = 'https://entitlement.auth.adobe.com/entitlement/AccessEnabler.swf';
    SWF_URLS[AdobePassAuthenticator.Environment.STAGING] = 'https://entitlement.auth-staging.adobe.com/entitlement/AccessEnabler.swf';
    var SWF_ELEMENT_ID = 'ae_swf';
    var JS_URLS = {};
    JS_URLS[AdobePassAuthenticator.Environment.PRODUCTION] = 'https://entitlement.auth.adobe.com/entitlement/js/AccessEnabler.js';
    JS_URLS[AdobePassAuthenticator.Environment.STAGING] = 'https://entitlement.auth-staging.adobe.com/entitlement/js/AccessEnabler.js';
    var JS_ELEMENT_ID = 'ae_js';

    var _accessEnablerSwfUrl = SWF_URLS[environment];
    var _accessEnablerJsUrl = JS_URLS[environment];
    var _redirectUrl = redirectUrl;
    var _accessEnabler = null;
    var _resolveInitialize = null;
    var _resolveAuthentication = null;
    var _resolveDeauthentication = null;
    var _resolveAuthorization = null;
    var _resolvePreauthorize = null;
    var _resolveAuthenticationInfo = null;
    var _resolveMetadataStatus = null;
    var _resolveSelectProvider = null;

    var _isAuthenticated = false;

    function swfLoaded() {
        var requestorConfigInfo = refreshless ? {
            callSetConfig: true,
            backgroundLogin: false,
            backgroundLogout: true
        } : null;

        _accessEnabler = document.getElementById(SWF_ELEMENT_ID);
        _accessEnabler.setProviderDialogURL('none');
        _accessEnabler.setRequestor(REQUESTOR, null, requestorConfigInfo);
        if (_resolveInitialize) {
            _resolveInitialize(true);
        }
    }

    function entitlementLoaded() {
        _accessEnabler = window.accessEnabler;
        var requestorConfigInfo = refreshless ? {
            callSetConfig: true,
            backgroundLogin: false,
            backgroundLogout: true
        } : null;
        _accessEnabler.setRequestor(REQUESTOR, null, requestorConfigInfo);
        if (_resolveInitialize) {
            _resolveInitialize(true);
        }
    }

    function setAuthenticationStatus(isAuthenticated, errorCode) {
        log.debug('AdobePassAuthenticator.setAuthenticationStatus', isAuthenticated, errorCode);
        _isAuthenticated = !!isAuthenticated;

        if (_resolveAuthentication) {
            _resolveAuthentication(_isAuthenticated);
            _resolveAuthentication = null;
        }

        if (_resolveSelectProvider) {
            _resolveSelectProvider(_isAuthenticated);
            _resolveSelectProvider = null;
        }

        if (_resolveDeauthentication) {
            _resolveDeauthentication(_isAuthenticated);
            _resolveDeauthentication = null;
        }
    }

    function setMetadataStatus(key, encrypted, data) {
        log.debug('AdobePassAuthenticator.setMetadataStatus', key, data);
        if (_resolveMetadataStatus) {
            _resolveMetadataStatus(data);
        }
        _resolveMetadataStatus = null;
    }

    function _displayProviderDialog(providers) {
        log.debug('AdobePassAuthenticator.displayProviderDialog', providers);
        if (_resolveAuthentication) {
            _resolveAuthentication(_isAuthenticated);
            _resolveAuthentication = null;
        }
        displayProviderDialogImpl(providers);
        /*
        .then(function(provider) {
         _accessEnabler.setSelectedProvider(provider);
         });
         */
    }

    function setToken(resourceId, token) {
        log.debug("Requested resource: " + resourceId + " tokenResult: " + token);
        if (_resolveAuthorization) {
            _resolveAuthorization({ resourceId: resourceId, token: token });
        }
    }

    function tokenRequestFailed(resourceId, errorCode, errorDetails) {
        if (errorCode != null || errorDetails != null) {
            log.error("Failure to authorize: " + errorDetails);
            if (_resolveAuthorization) {
                _resolveAuthorization({ errorCode: errorCode, errorDetails: errorDetails });
            }
        }
    }

    function setConfig() /* configXml */{
        // log.debug('setConfig', configXml);

    }

    function sendTrackingData(trackingEventType, trackingData) {
        if (trackingEventType === 'authenticationDetection') {
            var data = {
                success: trackingData[0],
                mvpd: trackingData[1],
                guid: trackingData[2],
                isTokenCached: trackingData[3],
                deviceType: trackingData[4],
                clientType: trackingData[5],
                os: trackingData[6]
            };

            log.debug('AdobePassAuthenticator.sendTrackingData', trackingEventType, data);
        }
    }

    function preauthorizedResources(authorizedResources) {
        log.debug('AdobePassAuthenticator.preauthorizedResources', authorizedResources);

        if (_resolveInitialize) _resolvePreauthorize(authorizedResources);
    }

    function embedFlash() {
        var flashvars = {};
        var params = {
            quality: 'low',
            allowscriptaccess: 'always',
            wmode: 'transparent',
            menu: 'false',
            align: 'middle',
            swliveconnect: 'true'
        };
        var attributes = {
            id: SWF_ELEMENT_ID,
            name: SWF_ELEMENT_ID
        };

        if (swfobject) {
            swfobject.embedSWF(_accessEnablerSwfUrl, CONTAINER_ELEMENT_ID, '1', '1', '10.1.53', '', flashvars, params, attributes);
        }
    }

    function embedJs() {
        var scriptTag = document.createElement('script');
        scriptTag.id = JS_ELEMENT_ID;
        scriptTag.type = 'text/javascript';
        scriptTag.async = true;
        scriptTag.src = _accessEnablerJsUrl;
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
    }

    function selectedProvider(result) {
        var mvpd = result.MVPD;
        var aeState = result.AE_State;

        if (_resolveInitialize) _resolveAuthenticationInfo({ mvpd: mvpd, aeState: aeState });
    }

    function bindCallbacks() {
        global.swfLoaded = swfLoaded;
        global.entitlementLoaded = entitlementLoaded;
        global.setAuthenticationStatus = setAuthenticationStatus;
        global.setMetadataStatus = setMetadataStatus;
        global.displayProviderDialog = _displayProviderDialog;
        global.setConfig = setConfig;
        global.sendTrackingData = sendTrackingData;
        global.preauthorizedResources = preauthorizedResources;
        global.selectedProvider = selectedProvider;
        global.setToken = setToken;
        global.tokenRequestFailed = tokenRequestFailed;
    }

    return assign(this, {
        /**
         * Initializes the Adobe Pass client
         * @function initialize
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<null>}
         **/
        initialize: function initialize(callback) {
            log.debug('AdobePassAuthenticator.initialize');

            return new Promise(function (resolve) {
                _resolveInitialize = resolve;
                bindCallbacks();
                if (accessEnableImpl === AdobePassAuthenticator.AccessEnablerType.FLASH) {
                    embedFlash();
                } else if (accessEnableImpl === AdobePassAuthenticator.AccessEnablerType.JAVASCRIPT) {
                    embedJs();
                }
            }).tap(function (isInitialized) {
                if (isFunction(callback)) {
                    callback(null, isInitialized);
                }
            });
        },


        /**
         * @function isAuthenticated
         * @override
         * @memberof AdobePassAuthenticator#
         * @returns {Boolean}
         **/
        isAuthenticated: function isAuthenticated() {
            return _isAuthenticated;
        },


        /**
         * @function setRedirectUrl
         * @override
         * @memberof AdobePassAuthenticator#
         * @returns boolean
         **/
        setRedirectUrl: function setRedirectUrl(redirectUrl) {
            if (typeof redirectUrl === 'string') {
                _redirectUrl = redirectUrl;
                return true;
            }
            return false;
        },


        /**
         * @function checkAuthentication
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         **/
        checkAuthentication: function checkAuthentication(callback) {
            log.debug('AdobePassAuthenticator.checkAuthentication');

            return new Promise(function (resolve) {
                _resolveAuthentication = resolve;
                _accessEnabler.checkAuthentication();
            }).tap(function (isAuthenticated) {
                if (isFunction(callback)) {
                    callback(null, isAuthenticated);
                }
            });
        },


        /**
         * @function authenticate
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {String} identity
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         **/
        authenticate: function authenticate(identity, callback) {
            var redirectUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _redirectUrl;

            log.debug('AdobePassClient.authenticate ' + identity);

            return new Promise(function (resolve) {
                _resolveAuthentication = resolve;
                _accessEnabler.getAuthentication(redirectUrl);
            }).tap(function (isAuthenticated) {
                if (isFunction(callback)) {
                    callback(null, isAuthenticated);
                }
            });
        },


        /**
         * @function deauthenticate
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         **/
        deauthenticate: function deauthenticate(callback) {
            log.debug('AdobePassAuthenticator.deauthenticate');

            return new Promise(function (resolve) {
                _resolveDeauthentication = resolve;
                _accessEnabler.logout();
            }).tap(function (isAuthenticated) {
                if (isFunction(callback)) {
                    callback(null, isAuthenticated);
                }
            });
        },


        /**
         * @function getAuthenticationInfo
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         **/
        getAuthenticationInfo: function getAuthenticationInfo(callback) {
            log.debug('AdobePassAuthenticator.getAuthenticationInfo');

            var getAuthenticationInfoPromise = new Promise(function (resolve) {
                _resolveAuthenticationInfo = resolve;
            });
            _accessEnabler.getSelectedProvider();

            if (isFunction(callback)) {
                callback(null, true);
            }

            return getAuthenticationInfoPromise;
        },


        /**
         * @function getMetadata
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         **/
        getMetadata: function getMetadata(key) {
            log.debug('AdobePassAuthenticator.getMetadata');
            var getMetadataPromise = new Promise(function (resolve) {
                _resolveMetadataStatus = resolve;
            });
            _accessEnabler.getMetadata(key || '');
            return getMetadataPromise;
        },


        /**
         * @function authorize
         * @override
         * @memberof AdobePassAuthenticator#
         * @param {Callback} callback
         * @returns {Promise.<Boolean>}
         **/
        authorize: function authorize(resource, callback) {
            log.debug('AdobePassClient.authorize ' + resource);

            return new Promise(function (resolve) {
                _resolveAuthorization = resolve;
                _accessEnabler.getAuthorization(resource);
            }).tap(function (authzResponse) {
                if (isFunction(callback)) {
                    callback(null, authzResponse);
                }
            });
        },


        /**
         * @function checkPreauthorizedResources
         * @memberof AdobePassAuthenticator#
         * @param {}
         * @returns {Promise.<Array>}
         **/
        checkPreauthorizedResources: function checkPreauthorizedResources() {
            var _this = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var hasCallback = isFunction(args[args.length - 1]);
            var resources = hasCallback ? args.slice(0, args.length - 1) : args;
            var callback = hasCallback ? args[args.length - 1] : null;

            return new Promise(function (resolve) {
                _resolvePreauthorize = resolve;
                _accessEnabler.checkPreauthorizedResources(resources);
            }).tap(function (authorizedResources) {
                authorizedResources.forEach(function (resource) {
                    _this.emit(AdobePassAuthenticator.EventType.PREAUTHORIZED, resource);
                });

                difference(resources, authorizedResources).forEach(function (resource) {
                    _this.emit(AdobePassAuthenticator.EventType.NOT_PREAUTHORIZED, resource);
                });

                if (isFunction(callback)) {
                    callback(null, resources);
                }
            });
        },
        selectProvider: function selectProvider(provider) {
            _accessEnabler.setSelectedProvider(provider.ID);
            return new Promise(function (resolve) {
                if (refreshless) {
                    _resolveSelectProvider = resolve;
                }
            });
        }
    });
}

AdobePassAuthenticator.Environment = {
    PRODUCTION: 'production',
    STAGING: 'staging'
};

AdobePassAuthenticator.EventType = {
    PREAUTHORIZED: 'preauthorized',
    NOT_PREAUTHORIZED: 'not_preauthorized'
};

AdobePassAuthenticator.AccessEnablerType = {
    JAVASCRIPT: 'js',
    FLASH: 'swf'
};

module.exports = AdobePassAuthenticator;


//////////////////
// WEBPACK FOOTER
// ./~/watch-authenticators/dist/AdobePassAuthenticator.js
// module id = 807
// module chunks = 0